export default __webpack_public_path__ + "static/media/Company.4f7a9bc0.png";